<template>
	<div :class="['file-preview', { loading }]">
		<q-icon
			size="24px"
			class="file-preview-icon"
			:name="recordVoice ? 'mic' : 'insert_drive_file'"
		/>
		<span
			class="file-preview-name"
			v-text="recordVoice ? `${$t('voiceRecording')} ${duration}` : file.name"
		/>
		<q-spinner v-if="loading" class="file-preview-loader" color="primary" size="24px" />
	</div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
	name: 'FilePreview',
	props: {
		file: {
			type: File,
			required: true
		},
		loading: {
			type: Boolean,
			default: false
		},
		recordVoice: {
			type: Boolean,
			default: false
		},
		duration: {
			type: String,
			default: '00:00'
		}
	}
});
</script>

<style scoped lang="scss">
.file-preview {
	align-items: center;
	display: flex;
	height: 40px;
	background: #e9e9e9;
	border-radius: 4px;
	padding: 0 8px;

	&-icon {
		color: rgba(0, 0, 0, 0.6);
	}

	&-name {
		color: rgba(0, 0, 0, 0.6);
		font-weight: 400;
		font-size: 14px;
		overflow: hidden;
		padding: 0 4px;
		white-space: nowrap;
		text-overflow: ellipsis;
	}

	&-loader {
		margin-left: auto;
	}

	&.loading {
		.file-preview-icon,
		.file-preview-name {
			color: #a6a6a6;
		}
	}
}

@media screen and (min-width: 767px) {
	.file-preview {
		max-width: 522px;
		height: 60px;
		width: auto;
		border-radius: 0.5rem;

		&-name {
			font-size: 16px;
		}
	}
}
</style>
